import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NavigationItem } from '../../../types';

@Component({
  selector: 'navigation-list-desktop',
  templateUrl: './navigation-list-desktop.component.html',
  styleUrls: ['./navigation-list-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationListDesktopComponent {
  @Input() items?: NavigationItem[];

  @Input() isOpen?: boolean;
  @Input() descriptionVisible = true;
}
